import { render, staticRenderFns } from "./PrintRatingDialog.vue?vue&type=template&id=748d0935"
import script from "./PrintRatingDialog.vue?vue&type=script&lang=js"
export * from "./PrintRatingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports